/**
 * 公共方法 获取查询表单中学校、该学校下的店铺
 */

export const getSchoolAndShop = {
    data() {
        return {
            autocompleteData: {
                isGoods: true,
                accountInfo: {},
                commercial_ids: '',
                school_name: '',
                school_id: '',
                shop_name: '',
                shop_id: '',
                good_name: '',
                good_id: '',
                schoolsList: [], // 所有学校集合
                shopsList: [], // 所有店铺集合
                goodsList: [], // 所有商品集合
            },
        }
    },
    created(){
        this.autocompleteData.accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
        this.autocompleteData.commercial_ids = this.autocompleteData.accountInfo.companyIds;
        this.getSchoolsList();
        this.getShopsList();
        if (this.autocompleteData.isGoods) this.getGoodsList();
    },
    methods: {
        /** 获取学校列表 */
        getSchoolsList () {
            let params = {
                commercial_ids: this.autocompleteData.commercial_ids,
                school_name: this.autocompleteData.school_name,
            }
            this.$api.post(this.$apiUrl.commercialSchoolsList, params,(res)=>{
                if (res.message == "success" && res.result) {
                    this.autocompleteData.schoolsList = res.data;
                } else {
                    this.$message.warning(res.message);
                    this.autocompleteData.schoolsList = [];
                }
            },(res)=>{
                this.$message.warning(res.message);
                this.autocompleteData.schoolsList = [];
            })
        },
        /** 获取门店列表 */
        getShopsList () {
            let params = {
                commercial_ids: this.autocompleteData.commercial_ids,
                shop_name: this.autocompleteData.shop_name,
                school_id: this.autocompleteData.school_id,
            }
            this.$api.post(this.$apiUrl.commercialShopsList, params,(res)=>{
                if (res.message == "success" && res.result) {
                    this.autocompleteData.shopsList = res.data;
                } else {
                    this.$message.warning(res.message);
                    this.autocompleteData.shopsList = [];
                }
            },(res)=>{
                this.$message.warning(res.message);
                this.autocompleteData.shopsList = [];
            })
        },
        /** 获取商品列表 */
        getGoodsList () {
            let params = {
                skuCode: this.autocompleteData.good_name,
                schoolCode: this.autocompleteData.school_id,
                shopCode: this.autocompleteData.shop_id,
            }
            this.$apiJava.post(this.$apiUrl.commercialGood, params,(res)=>{
                if (res.message == "success" && res.result) {
                    this.autocompleteData.goodsList = res.data;
                } else {
                    this.$message.warning(res.message);
                    this.autocompleteData.goodsList = [];
                }
            },(res)=>{
                this.$message.warning(res.message);
                this.autocompleteData.goodsList = [];
            },'gc')
        },
        /** 动态筛选 */
        querySchoolSearch(queryString, cb, key, data) {
            let list = data ? data : this.autocompleteData[key];
            let results = queryString ? list.filter(this.listFilter(queryString, key)) : list;
            console.log(list);
            console.log(results);
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        listFilter(queryString, type) {
            return (results) => {
                let key;
                if (type == 'schoolsList') key = 'school_name'
                else if (type == 'shopsList') key = 'shop_name'
                else if (type == 'goodsList') key = 'gdName'
                else if (type == 'payWayList') key = 'desc'
                return (results[key].indexOf(queryString.toLowerCase()) > -1);
            };
        },
        /** 清除选择项 */
        clearSelect (type, level) {
            if (type == 'schoolsList') {
                this.autocompleteData.school_name = '';
                this.autocompleteData.school_id = '';
                this.autocompleteData.shop_name = '';
                this.autocompleteData.shop_id = '';
                this.autocompleteData.good_name = '';
                this.autocompleteData.good_id = '';
                this.getShopsList();
                if (this.autocompleteData.isGoods) this.getGoodsList();
            } else if (type == 'shopsList') {
                this.autocompleteData.shop_name = '';
                this.autocompleteData.shop_id = '';
                this.autocompleteData.good_name = '';
                this.autocompleteData.good_id = '';
                if (this.autocompleteData.isGoods) this.getGoodsList();
            } else if (type == 'goodsList') {
                this.autocompleteData.good_name = '';
                this.autocompleteData.good_id = '';
            }
        },
        /** 选中回调 */
        handleSelect (item, key) {
            console.log(item);
            console.log(key);
            if (key == 'schoolsList') {
                this.autocompleteData.shop_name = '';
                this.autocompleteData.shop_id = '';
                this.autocompleteData.school_name = item.school_name;
                this.autocompleteData.school_id = item.school_id;
                this.getShopsList();
                this.getGoodsList();
            } else if (key == 'shopsList') {
                this.autocompleteData.shop_name = item.shop_name;
                this.autocompleteData.shop_id = item.id;
                this.getGoodsList();
            } else if (key == 'goodsList') {
                this.autocompleteData.good_name = item.gdName;
                this.autocompleteData.good_id = item.skuCode;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./vue/mixins/getSchoolAndShop.js